import { Accordion, AccordionSummary, Box, Button, Switch } from '@material-ui/core';
import { Delete, UnfoldMore } from '@material-ui/icons';

export const ChatControl = ({ onUpdate, value, onDelete, isSelected }) => {
    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={false}>
                <AccordionSummary
                    className='handle'
                    expandIcon={<Button
                        size="small"
                        variant='contained'
                        onClick={() => onDelete()}
                        startIcon={<Delete />}
                        color='default'>
                        Remove
                    </Button>}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.5 8.25H16.5M7.5 11.25H12M2.25 12.76C2.25 14.36 3.373 15.754 4.957 15.987C6.086 16.153 7.227 16.28 8.38 16.366C8.73 16.392 9.05 16.576 9.245 16.867L12 21L14.755 16.867C14.8516 16.7233 14.9798 16.6035 15.1297 16.5166C15.2795 16.4298 15.4472 16.3783 15.62 16.366C16.7652 16.2805 17.9069 16.1541 19.043 15.987C20.627 15.754 21.75 14.361 21.75 12.759V6.741C21.75 5.139 20.627 3.746 19.043 3.513C16.711 3.17072 14.357 2.99926 12 3C9.608 3 7.256 3.175 4.957 3.513C3.373 3.746 2.25 5.14 2.25 6.741V12.759V12.76Z" stroke="#CECECE" stroke-width="1.26316" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Live Chats
                        </div>
                    </Box>
                </AccordionSummary>
            </Accordion>
        </div>
    )
}
